import { motion } from "motion/react";

/**
 * Standard SEOintent logo — used across marketing pages AND dashboard.
 * variant="white" → use the white variant for dark backgrounds.
 */
export const Logo = ({ className = "", variant = "red", size = "md" }) => {
  const src = variant === "white" ? "/Seo-intent-logo-white.png" : "/logo-red.png";
  const heights = { sm: "h-6", md: "h-8", lg: "h-10", xl: "h-14" };
  const h = heights[size] || heights.md;
  return (
    <motion.div
      className={`inline-flex items-center ${className}`}
      whileHover={{ scale: 1.03 }}
      transition={{ duration: 0.2 }}
    >
      <img
        src={src}
        alt="SEOintent"
        className={`${h} w-auto object-contain`}
        data-testid="seointent-logo"
      />
    </motion.div>
  );
};
